export default "__VITE_ASSET__CCbP4QDo__"